<template>
  <div class="container-fluid">
    <Alert :message="success" type="alert alert-success" v-if="success" />
    <Alert :message="error" type="alert alert-danger" v-if="error" />

    <!-- new license modal open -->
    <div
      class="modal fade"
      id="newcategory"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Add Requirement Doc
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group mx-3">
              <div class="form-group ml-2 mt-5">
                <label for="name">Name</label>
                <input
                  v-model="name"
                  type="text"
                  id="name"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              @click="newDoc"
              type="submit"
              class="btn btn-success"
              data-dismiss="modal"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- new license modal close -->

    <!-- edit license modal open -->
    <div
      class="modal fade"
      id="editlicense"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Update Requirement Doc
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group ml-2 mt-5">
              <label for="name">Name</label>
              <input
                v-model="name"
                type="text"
                id="name"
                class="form-control"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              @click="updateDoc"
              type="submit"
              class="btn btn-success"
              data-dismiss="modal"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- edit license modal close -->

    <!-- Modal -->
    <div
      class="modal fade"
      id="deletecategory"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Delete Requirement Doc
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Are you sure you want to do this ?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              @click="deleteDoc"
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal end -->

    <div class="row d-flex justify-content-between">
      <div></div>
      <button
        @click="getKeyAndId(requirementId)"
        data-toggle="modal"
        data-target="#newcategory"
        class="btn m-3 p-1 btn-primary"
      >
        New Requirement Doc
      </button>
    </div>
    <div class="row">
      <div class="col">
        <div class="card border-left-danger">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <div class="row mt-4">
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        >
                          <label class="d-inline-flex align-items-center">
                            Show&nbsp;
                            <b-form-select
                              v-model="perPage"
                              size="sm"
                              :options="pageOptions"
                            ></b-form-select
                            >&nbsp;entries
                          </label>
                        </div>
                      </div>
                      <!-- Search -->
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_filter"
                          class="dataTables_filter text-md-right"
                        >
                          <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                              v-model="filter"
                              type="search"
                              placeholder="Search..."
                              class="form-control form-control-sm ml-2"
                            ></b-form-input>
                          </label>
                        </div>
                      </div>
                      <!-- End search -->
                    </div>
                    <div class="table-responsive" style="min-height: 200px;">
                      <b-table
                        :items="requirementDocs"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sorrt-desc.sync="sortDesc"
                        :fit-by.sync="sortBy"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                        hover
                      >
                        <template v-slot:cell(action)="row">
                          <div class="dropdown">
                            <a
                              href="#"
                              data-toggle="dropdown"
                              data-caret="false"
                              class="text-muted"
                              ><b-icon-three-dots></b-icon-three-dots
                            ></a>
                            <div class="dropdown-menu dropdown-menu-right p-3">
                              <button
                                @click="getId(row.item.id, row.item.name)"
                                data-toggle="modal"
                                data-target="#editlicense"
                                class="btn m-0 p-1 text"
                              >
                                Edit Requirement Doc
                              </button>
                              <button
                                @click="getKeyAndId(row.item.id)"
                                data-toggle="modal"
                                data-target="#deletecategory"
                                class="btn m-0 p-1 text-danger"
                              >
                                Delete Requirement Doc
                              </button>
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "@/components/Alert";
import { mapGetters } from "vuex";
// import store from "@/store";
import ToasterMixin from "@/mixin/toasterMixin.js";

export default {
  components: {
    Alert: Alert,
  },
  data() {
    return {
      //  data table
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "id", sortable: true, label: "ID" },
        { key: "name", sortable: true, label: "Name" },
        { key: "Action" },
      ],

      //   table data
      requirementId: this.$route.params.requirementId,
      entityId: this.$route.params.id,
      typeId: this.$route.params.typeId,
      id: null,
      requirementDocs: [],
      key: null,
      success: null,
      error: null,
      name: "",
    };
  },
  methods: {
    getKeyAndId(id) {
      this.id = id;
    },
    getId(id, name) {
      console.log(id);
      this.id = id;
      this.name = name;
    },
    newDoc() {
      const data = {
        type_id: parseInt(this.typeId),
        name: this.name,
      };

      console.log(data);

      this.$store
        .dispatch("addDoc", data)
        .then((response) => {
          console.log(response);
          if (response.status == 201) {
            this.fetchData();
            this.toast({
              message: "Requirement Doc Created!",
              type: "success",
            });
            this.name = "";
            this.id = "";
          }
        })
        .catch((err) => {
          console.log("err", err);
          if (err?.response?.data) {
            this.toast({ message: err?.response?.data.error, type: "error" });
          }
        });
    },
    updateDoc() {
      const doc = {
        data: {
          type_id: this.typeId,
          name: this.name,
        },
        id: this.id,
      };

      console.log(doc);

      this.$store
        .dispatch("updateDoc", doc)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            this.fetchData();
            this.toast({
              message: "Requirement Doc Updated!",
              type: "success",
            });

            this.name = "";
            this.id = "";
          }
        })
        .catch((err) => {
          console.log("err", err);
          if (err?.response?.data) {
            this.toast({ message: err?.response?.data.error, type: "error" });
          }
        });
    },
    deleteDoc() {
      this.$store
        .dispatch("deleteDoc", this.id)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            this.fetchData();
            this.toast({
              message: "Requirement Doc Deleted!",
              type: "error",
            });
            this.name = "";
            this.id = "";
          }
        })
        .catch((err) => {
          console.log("err", err);
          if (err?.response?.data) {
            this.toast({ message: err?.response?.data.error, type: "error" });
          }
        });
    },
    fetchData() {
      const params = {
        regulatorId: this.requirementId,
        typeId: this.typeId,
      };

      this.$store
        .dispatch("fetchDocs", params)
        .then((response) => {
          console.log(response);
          const logistics = response.data;
          this.requirementDocs = logistics;
        })
        .catch((err) => {
          console.log("err", err);
          this.error = "Network Error";
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  computed: {
    // ...mapGetters(["licenses"]),
    rows() {
      return this.requirementDocs && this.requirementDocs.length;
    },
  },
  created() {
    console.log(this.requirementId, this.typeId);
    this.fetchData();
  },
};
</script>

<style></style>
